import {
  Button,
  Flex,
  FormControl,
  FormLabel,
  Image,
  Input,
  Link,
  VStack,
  useToast,
  Text,
} from "@chakra-ui/react";
import { useState } from "react";
import axiosInstance, { axiosFileUpload } from "../apis/axios.instance";
import { getToast } from "../utils";
import { useNavigate } from "react-router-dom";
import { useGlobal } from "../contexts/Globals";
import { hasEditPermissionApi } from "../apis/role.api";

export default function DangNhap() {
  const toast = useToast();
  const { setRole } = useGlobal();
  const navigate = useNavigate();
  const [username, setUserName] = useState("admin");
  const [password, setPassword] = useState("123456");

  const handleLogin = async () => {
    console.log(process.env.REACT_APP_TUTORIAL_VIDEO_URL);
    try {
      const result: string = await axiosInstance.post("login", {
        username,
        password,
      });
      window.localStorage.setItem("accessToken", result);
      window.localStorage.setItem("userName", username);

      axiosInstance.interceptors.request.use((conf) => {
        if (conf && conf.headers) {
          conf.headers.Authorization = `Bearer ${result}`;
        }
        return conf;
      });
      axiosFileUpload.interceptors.request.use((conf) => {
        if (conf && conf.headers) {
          conf.headers.Authorization = `Bearer ${result}`;
        }
        return conf;
      });

      if (setRole) {
        const hasEditRole = await hasEditPermissionApi(username);
        setRole(hasEditRole);
      }

      navigate("/map");
    } catch (ex) {
      toast(getToast("Đăng nhập thất bại. Vui lòng kiểm tra lại thông tin."));
    }
  };

  return (
    <Flex
      flex={1}
      bgColor="whiteAlpha.50"
      justifyContent="center"
      alignItems="center"
      flexDirection="column"
    >
      <Image src="./imgs/logo-desktop.jpg" mb="15px" width="300px" />
      <Text fontWeight="bold" fontSize="24px" color="#013783" mb="20px">
        PHÂN HỆ QUẢN LÝ GIÁ ĐẤT
      </Text>
      <Flex
        w="50%"
        justifyContent="space-evenly"
        shadow="lg"
        p="20px !important"
        borderRadius="10px"
        bg="white"
      >
        <Flex
          bgImage="./imgs/login.jpg"
          h="300px"
          w="38%"
          bgSize="cover"
          mr="20px"
          borderRadius="8px"
        ></Flex>
        <VStack w="70%">
          <FormControl as="fieldset">
            <FormLabel>Tên đăng nhập:</FormLabel>
            <Input
              type="text"
              value={username}
              onChange={(e) => setUserName(e.target.value)}
            />
          </FormControl>
          <FormControl as="fieldset" mt="20px !important">
            <FormLabel>Mật khẩu:</FormLabel>
            <Input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </FormControl>
          <Button w="full" mt="20px !important" onClick={handleLogin}>
            Đăng Nhập
          </Button>

          <Flex>
            <Link
              href={`./hdsd.pdf`}
              target="_blank"
              color="blue.400"
              fontSize="12px"
              textDecoration="underline"
            >
              Hướng dẫn sử dụng
            </Link>
          </Flex>
          <Flex>
            <Link
              href={process.env.REACT_APP_TUTORIAL_VIDEO_URL || ""}
              target="_blank"
              color="blue.400"
              fontSize="12px"
              textDecoration="underline"
            >
              Video hướng dẫn
            </Link>
          </Flex>
        </VStack>
      </Flex>
    </Flex>
  );
}
